import * as z from "zod";
import { THREE_B_AI_PROVIDER_ID } from "../aiProviders";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const setManagedAIProviderDisabledSchema = z.object({
  disabled: z.boolean(),
});

export const setManagedAIProviderDisabled = mutator({
  schema: setManagedAIProviderDisabledSchema,
  resolve: {},
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    if (args.disabled) {
      const active = await tx.run(
        zql.aiProviders.where("tenantId", ctx.tenantId).where("active", true)
      );
      // A 3B managed AI provider stops with managed AI, so it can't be the
      // default that takes over.
      if (
        active.length === 0 ||
        active.some((config) => config.provider === THREE_B_AI_PROVIDER_ID)
      ) {
        throw userFacingError(
          "Set another AI provider as the default before disabling the managed provider"
        );
      }
    }
    const now = Date.now();
    await tx.mutate.tenants.update({
      id: ctx.tenantId,
      managedAiProviderDisabledAt: args.disabled ? now : null,
      updatedAt: now,
    });
  },
});
